<template>
  <div class="mod-user">
    <div class="searchBox">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
        <el-form-item label="类型">
          <el-select class="item-choose" @change="getDataList" v-model="dataForm.tagId" size="small" filterable clearable placeholder="请选择">
            <el-option label="订单问题" value="1"></el-option>
            <el-option label="客服问题" value="2"></el-option>
            <el-option label="平台问题" value="3"></el-option>
            <el-option label="物品问题" value="4"></el-option>
            <el-option label="快递问题" value="5"></el-option>
            <el-option label="其他问题" value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" type="primary">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table :data="dataList" height="72vh" :row-class-name="tableRowClassName" @row-click="rowClick" :row-style="selectedHighlight"  border size="small" v-loading="dataListLoading" style="width: 100%;">
        <el-table-column label="投诉/建议" prop="tagList" fixed="left" width="340">
          <template  slot-scope="scope">
            <span v-for="(item,index) in scope.row.tagList" :key="index" size="small">
              <el-tag v-if="item === '1'" size="small">订单问题</el-tag>
              <el-tag v-if="item === '2'" size="small" type="success">客服问题</el-tag>
              <el-tag v-if="item === '3'" size="small" type="danger">平台问题</el-tag>
              <el-tag v-if="item === '4'" size="small">物品问题</el-tag>
              <el-tag v-if="item === '5'" size="small" type="warning">快递问题</el-tag>
              <el-tag v-if="item === '6'" size="small" type="info">其他问题</el-tag>
            </span>
          </template>
        </el-table-column>
        <af-table-column  prop="content" label="问题描述" align="center">
        </af-table-column>
        <el-table-column  prop="orderNo" label="订单编号" width="250" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <af-table-column  prop="phone" width="140"  label="联系电话" align="center">
        </af-table-column>
        <af-table-column  prop="createTime" width="140"  label="提交时间" align="center">
        </af-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <!-- 弹窗, 新增 / 修改 -->
    <declaration-detail ref="detail" @refreshDataList="getDataList"></declaration-detail>
  </div>
</template>

<script>
import declarationDetail from './details/declaration-detail'
export default {
  data () {
    return {
      dataForm: {
        name: null,
        show: null,
        status: 1,
        tagId: null
      },
      isCustomer: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      getIndex: -1,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      detailVisible: false
    }
  },
  components: {
    declarationDetail
  },
  activated () {
    if (this.currentUser.customerId) {
      this.isCustomer = true
      this.dataForm.customerId = this.currentUser.customerId
    }
    this.getDataList()
  },
  computed: {
    currentUser: {
      get () {
        return this.$store.state.user.currentUser
      }
    },
    dictTypeMap: {
      get () { return this.$store.state.common.dictTypeMap }
    }
  },
  methods: {
    /**
     * 点击表格变色start
     */
    selectedHighlight ({ row, rowIndex }) {
      if ((this.getIndex) === rowIndex) {
        return {
          'background-color': 'rgb(250, 195, 100)'
        }
      }
    },
    // 如果为已取消时，该行置灰
    tableRowClassName ({ row, rowIndex }) {
      row.index = rowIndex
      if (row.status === 12) {
        return 'cancel-row'
      }
      return ''
    },
    rowClick (row) {
      this.getIndex = row.index
    },
    /**
     * 点击表格变色end
     */
    // 查看照片
    viewPhoto (row) {
      this.$refs.viewPhoto.init(row.id)
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/customer/findComplaint'),
        method: 'get',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'limit': this.pageSize,
          'tagId': this.dataForm.tagId
        })
      }).then(({ data }) => {
        if (data) {
          this.dataList = data
          this.totalPage = data.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 详情
    detail (id) {
      this.detailVisible = true
      this.$nextTick(() => {
        this.$refs.detail.init(id)
      })
    },
    // 新增 / 修改
    addOrUpdateHandle (todo, rows) {
      this.$nextTick(() => {
        this.$refs.detail.init(todo, rows)
      })
    },
    // 禁用或启用
    disableOrEnable (row) {
      let title = row.status === 1 ? '禁用' : '启用'
      this.$confirm('确定对【' + row.name + '】进行【' + title + '】操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/entranceType/updateStatus'),
          method: 'post',
          data: {
            id: row.id,
            status: row.status === 1 ? 2 : 1
          }
        }).then(({ data }) => {
          if (data) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error('操作失败')
          }
        })
      }).catch(() => {})
    },
    // 删除
    deleteHandle (id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/sys/user/delete'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>
